/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getProfile.defs.js'
export { main as default } from './getProfile.defs.js'
